import { appBarTranslations as appBarTranslationsEn } from '@I18n/en/app_bar';

export const appBarTranslations = {
  company_details: "Détails de l'entreprise",
  axa_header: 'AXA Mon Epargne Entreprises',
} satisfies typeof appBarTranslationsEn;
